import { createStore } from 'vuex'

export default createStore({
  state: {
    speciesList: [
      // 物种列表数据
    ],
    features: [
      // 功能特性数据
    ],
    productList: [
      // 产品列表数据
    ],
    downloadLinks: [
      // 下载链接数据
    ]
  },
  mutations: {
    setSpeciesList(state, payload) {
      state.speciesList = payload;
    },
    setFeatures(state, payload) {
      state.features = payload;
    },
    setProductList(state, payload) {
      state.productList = payload;
    },
    setDownloadLinks(state, payload) {
      state.downloadLinks = payload;
    }
  },
  actions: {
    fetchSpeciesList({ commit }) {
      // 模拟异步请求
      setTimeout(() => {
        commit('setSpeciesList', [
          // 物种列表数据
        ]);
      }, 1000);
    },
    fetchFeatures({ commit }) {
      // 模拟异步请求
      setTimeout(() => {
        commit('setFeatures', [
          // 功能特性数据
        ]);
      }, 1000);
    },
    fetchProductList({ commit }) {
      // 模拟异步请求
      setTimeout(() => {
        commit('setProductList', [
          // 产品列表数据
        ]);
      }, 1000);
    },
    fetchDownloadLinks({ commit }) {
      // 模拟异步请求
      setTimeout(() => {
        commit('setDownloadLinks', [
          // 下载链接数据
        ]);
      }, 1000);
    }
  },
  modules: {}
})